import React from "react";
import { Link } from "react-router-dom";
import { HeroImage1,HeroImage2,HeroImage3,HeroImage4,HeroImage5,HeroImage6,HeroImage7, Hero2, Layananimg, Aboutusimg, Person1, Person2, Dokumentasi, Heroaboutus } from "../assets/images";
import { LogoInverted } from "../assets/icons";
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useEffect,useState} from 'react';

function Home() {
  const [slide, setSlide] = useState(0);
  useEffect(() => {
    AOS.init({
      once: true,
      duration: 1500,
    });
  }, []);

  const slides = [HeroImage1, HeroImage7];
  const nextSlide = () => {
    setSlide((slide + 1) % slides.length);
  };

  const prevSlide = () => {
    setSlide((slide - 1 + slides.length) % slides.length);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      console.log("change");
      nextSlide();
    }, 5000); // Auto-advance every 3 seconds

    return () => {
      clearInterval(interval);
    };
  }, [slide, slides]);

  // Render condition to display content only for HeroImage1
  const renderHeroContent = () => {
    if (slide === 0) {
      return (
        <div className="flex-1 md:order-1 order-2 flex justify-center">
          <div data-aos="fade-left" className="w-2/3">
            <img src={LogoInverted} alt="Logo Temps" className="object-cover md:w-full w-8/12" />
            <h2 className="text-xl font-semibold mt-3 text-white tracking-wide">
              Perjalanan Panjang Kami Yang Bertanggungjawab
            </h2>
            <div className="mt-6 mb-14">
              <a
                style={{ boxShadow: "5px 5px 0 rgba(10,10,10,.5)" }}
                className="bg-white rounded-md px-12 py-2 text-xl text-black hover:bg-hovsecondary font-medium"
                href="https://wa.me/6281213094426/?text=Halo%2C%20saya%20ingin%20menanyakan%20terkait%20jasa%20yang%20disediakan%20oleh%20Temps."
              >
                Contact Us
              </a>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="flex-1 md:order-1 order-2 flex justify-center">
          <div data-aos="fade-left" className="w-2/3">
            <img src={LogoInverted} alt="Logo Temps" className="opacity-0 object-cover md:w-full w-8/12" />
            <h2 className="text-xl font-semibold mt-3 text-white tracking-wide opacity-0">
              Perjalanan Panjang Kami Yang Bertanggungjawab
            </h2>
            <div className="mt-6 mb-14">
              <a
                style={{ boxShadow: "5px 5px 0 rgba(10,10,10,.5)" }}
                className=" opacity-0 bg-white rounded-md px-12 py-2 text-xl text-black hover:bg-hovsecondary font-medium"
                href="https://wa.me/6281213094426/?text=Halo%2C%20saya%20ingin%20menanyakan%20terkait%20jasa%20yang%20disediakan%20oleh%20Temps."
              >
                Contact Us
              </a>
            </div>
          </div>
        </div>
      );
    }
  };

  return (
    <div className="pt-12">

      {/* Header Desktop */}
      <div
        style={{
          backgroundImage: `url(${slides[slide]})`,
          backgroundPosition: "center",
          backgroundAttachment: "scroll",
          backgroundSize: "cover",
          transition: "background-image 0.5s ease", // Add transition for smooth slide change
        }}
        className="md:w-full md:flex-row flex-col w-full mx-auto md:flex justify-center items-center py-48 hidden"
      >
        {renderHeroContent()} {/* Render content conditionally */}
        <div className="flex-1 flex justify-center md:order-2 order-1"></div>
      </div>

      {/* Header Small */}
      <div style={{ backgroundImage: `url(${Hero2})`, backgroundPosition: 'center', backgroundAttachment: 'fixed' }} className="md:hidden mt-2 block">
        <div className="container pt-36 pb-36 s:w-screen w-4/5 mx-auto flex justify-center"  >
          <div className="flex-1 flex flex-col justify-center items-center">
            <img data-aos="fade-left" src={LogoInverted} alt="Logo Temps" className="object-cover md:w-full w-8/12" />
            <h2 data-aos="fade-right" style={{ textShadow: '1.5px 1.5px 0 rgba(10,10,10,.5)' }} className="text-xl text-center mt-8 text-white tracking-wide ">
              Perjalanan Panjang Kami Yang Bertanggungjawab
            </h2>
            <div data-aos="fade-left" className="mt-11">
              <Link
                className="bg-white font-bold px-8 py-2 text-xl text-primary"
                to="/program"
              >
                Contact Us
              </Link>
            </div>
          </div>

        </div>
      </div>

      {/* Tentang Kami */}
      <div className="md:w-10/12 w-11/12 md:flex-row flex-col mt-32 mx-auto flex justify-center items-center">
        <div data-aos="flip-left" className="flex-1 md:order-2 flex justify-center">
          <img src={Aboutusimg} alt="Tentang Kami" className="object-cover md:w-9/12 w-8/12" />
        </div>
        <div data-aos="fade-right" className="flex-1 md:order-1 md:mt-0 mt-11">
          <h2 className="text-4xl font-bold text-primary tracking-wide ">
            Tentang Kami
          </h2>
          <p className="text-lg text-primary tracking-wide mt-8">
            TEMPS merupakan Grup Perusahaan di Indonesia
            yang sudah lebih dari satu dekade berkontribusi
            pada pangan dan ekonomi khususnya bagi masyarakat
            di Indonesia bagian barat. Sebagai penyedia layanan
            konsultasi hukum dan legalitas bisnis yang profesional,
            TEMPS berperan aktif menjangkau berbagai sektor penting,
            mulai dari perdagangan, manufaktur, konstruksi, transportasi hingga konsultan hukum yang andal.
          </p>
          <div className="mt-11">
            <Link
              style={{ boxShadow: "5px 5px 0 rgba(10,10,10,.5)" }}
              className="hover:bg-secondary rounded-md px-12 py-2 text-xl text-primary font-bold bg-hovsecondary"
              to="/aboutus"
            >
              Selengkapnya
            </Link>
          </div>
        </div>
      </div>

      {/* Layanan */}
      <div className="md:w-10/12 w-11/12 md:flex-row flex-col mt-32 mx-auto flex justify-center items-center">
        <div data-aos="flip-right" className="flex-1 flex justify-center">
          <img src={Layananimg} alt="Layanan Kami" className="object-cover md:w-9/12 w-8/12" />
        </div>
        <div data-aos="fade-left" className="flex-1 md:mt-0 mt-11">
          <h2 className="text-4xl font-bold text-primary tracking-wide ">
            Layanan
          </h2>
          <p className="text-lg text-primary tracking-wide mt-8">
            Sebagai mitra konsultan hukum professional yang berfokus pada kualitas,
            TEMPS hadir untuk mendukung berbagai sektor bisnis yang mencakup law firm,
            paten merek, legalitas dan izin usaha, agro resources, kontruksi, manufacturing,
            advertising, serta informasi dan logistik. Bersama tim ahli yang berpengalaman,
            kami berfokus melindungi hak-hak Anda, memastikan kepatuhan regulasi, dan
            memberikan solusi hukum terbaik di setiap perjalanan bisnis Anda
          </p>
          <div className="mt-11">
            <Link
              style={{ boxShadow: "5px 5px 0 rgba(10,10,10,.5)" }}
              className="hover:bg-secondary rounded-md px-12 py-2 text-xl text-primary font-bold bg-hovsecondary"
              to="/layanan"
            >
              Selengkapnya
            </Link>
          </div>
        </div>
      </div>


      {/* Teams*/}
      <p data-aos="fade-up" className="text-4xl font-bold pt-32 md:ml-0 lg:ml-0 ml-0 justify-start md:text-center lg:text-center text-center text-primary mb-8 mt-0 ">
        Dewan Direksi
      </p>
      <div className="flex flex-col md:flex-row md:flex-wrap justify-center items-center space-y-4 md:space-x-4 mx-auto">

        {/* Card Team 1 */}
        <div data-aos="flip-left" className="pt-4 flex flex-col overflow-hidden rounded-lg cursor-pointer h-90 w-80 lg:w-80 md:w-80 m-0">
          <img alt="profil" src={Person2} className="relative z-10 mx-auto object-cover rounded-lg h-40 w-40  border-2 border-secondary -mb-20" />
          <div className="py-4 pt-24 bg-primary rounded-lg shadow-lg z-0 border-primary border-2">
            <div className="text-center">
              <p className="text-lg text-secondary font-semibold">
                Syahru Ramadhan
              </p>
              <p className="text-lg font-light text-white ">
                CEO Temps International
              </p>
            </div>
          </div>
        </div>

        {/* Card Team 2 */}
        <div data-aos="flip-left" className="flex flex-col overflow-hidden rounded-lg cursor-pointer h-90  w-80 lg:w-80 md:w-80 m-3">
          <img alt="profil" src={Person1} className="relative z-10 mx-auto object-cover rounded-lg h-40 w-40  border-2 border-secondary -mb-20" />
          <div className="py-4 pt-24 bg-primary rounded-lg shadow-lg z-0 border-primary border-2">
            <div className="text-center">
              <p className="text-lg text-secondary font-semibold ">
                Dr. Sahat Tambunan, SH, MH, CLA.,
              </p>
              <p className="text-lg font-light text-white ">
                Head Consultant Temps Int. Law Firm
              </p>
            </div>
          </div>
        </div>

      </div>

      {/* Dokumentasi */}
      <div className="md:w-10/12 w-11/12 md:flex-row flex-col mt-32 mx-auto flex justify-center items-center">
        <div data-aos="flip-right" className="flex-1 flex justify-center">
          <img src={Dokumentasi} alt="Layanan Kami" className="object-cover md:w-9/12 w-8/12" />
        </div>
        <div data-aos="fade-left" className="flex-1 md:mt-0 mt-11">
          <h2 className="text-4xl font-bold text-primary tracking-wide ">
            Berkolaborasi dan Tumbuh Bersama <span className="text-secondary">TEMPS</span>
          </h2>
          <p className="text-lg text-primary tracking-wide mt-8">
            Lebih dari 15 tahun TEMPS sebagai Group Perusahaan telah melalui perjalanan panjang
            dan banyak menemukan berbagai tantangan dan hambatan. Namun hal tersebut membuat kami
            terus tumbuh dan berkembang hingga saat ini. Hal ini tentu bukan hanya sekedar
            pelaksanaan manajerial yang profesional, melainkan juga adanya andil kesetiaan dan
            kepercayaan para pelanggan dan partners dalam membina kerjasama dan hubungan yang baik
          </p>
        </div>
      </div>

      {/* Alamat Maps Perusahaan */}
      <h3 data-aos="fade-down" className="text-center text-4xl font-bold text-primary tracking-wide pb-12 pt-32">
        Visit Us
      </h3>
      <div className="md:w-10/12 w-11/12 md:flex-row flex-col mb-16 flex justify-center items-center">
        <div data-aos="flip-right" className="flex-1 justify-center md:w-full -ml-8 md:ml-20 w-10/12 md:w-10/12">
          <h3 className="text-xl text-center font-bold text-primary mt-2 pl-16 uppercase">
            Kantor 1
          </h3>
          <iframe
            className="mt-2 rounded-xl filter drop-shadow-md"
            width="120%"
            height="400"
            frameBorder="0"
            scrolling="no"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3966.2950397039335!2d106.85549089999999!3d-6.2247745!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69f3851a71e45b%3A0x1ec0fbd38b48c8c6!2sPlaza%20Kaha%2C%20Jl.%20KH%20Abdullah%20Syafei%20No.21%20C%2C%20RT.5%2FRW.6%2C%20Bukit%20Duri%2C%20Kec.%20Tebet%2C%20Kota%20Jakarta%20Selatan%2C%20Daerah%20Khusus%20Ibukota%20Jakarta%2012840!5e0!3m2!1sen!2sid!4v1693475221406!5m2!1sen!2sid"
          >
          </iframe>
        </div>
        <div data-aos="flip-left" className="flex-1 md:w-10/12 -ml-8 md:ml-40 w-10/12 mt-10 md:mt-0">
          <div>
            <h3 className="text-xl text-center font-bold text-primary pl-16 mt-2 uppercase">
              Kantor 2
            </h3>
            <iframe
              className="mt-2 rounded-xl filter drop-shadow-md"
              width="120%"
              height="400"
              frameBorder="0"
              scrolling="no"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3966.3481993550295!2d106.81366650000001!3d-6.2177299999999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69f154b4f332ed%3A0x8a8b316b116dd0b!2sCEO%20SUITE%20Wisma%20GKBI!5e0!3m2!1sen!2sid!4v1693475454786!5m2!1sen!2sid"
            >
            </iframe>
          </div>
        </div>
      </div>


    </div>

  );
}

export default Home;
